import React from "react";
import { Link } from "react-router-dom";
export function Logo({
  compact = false
}: {
  compact?: boolean;
}) {
  return <Link to="/" aria-label="Post Bail Bonds Inc. — Bail with Respect, home" className="group flex shrink-0 items-center gap-3 rounded-xl" data-id="element-53" data-mp="1hw6zan341dyl">
      <span className={`grid place-items-center rounded-xl border border-gold/40 bg-navy-800 font-serif italic text-gold-soft transition-[width,height,font-size] duration-200 ease-out ${compact ? "h-9 w-9 text-lg" : "h-11 w-11 text-xl"}`} aria-hidden="true" data-id="element-54" data-mp="1rn1l5qcg2bji">
        P
      </span>
      <span className="flex flex-col leading-none" data-id="element-55" data-mp="13wp49pz814gs">
        <span className="whitespace-nowrap font-serif text-[1.15rem] text-white" data-id="element-56" data-mp="14037t1jmfjpt">
          Post Bail Bonds <span className="text-gold-soft" data-id="element-57" data-mp="18ugy4pjff0nm">Inc.</span>
        </span>
        <span className="mt-1.5 whitespace-nowrap text-[0.65rem] font-medium uppercase tracking-[0.18em] text-white/60" data-id="element-58" data-mp="2fcdr8hch63hl">
          Bail with Respect
        </span>
      </span>
    </Link>;
}